import React from 'react';
import { Link } from 'react-router-dom';
import { Rating } from '@material-ui/lab';
import { Tooltip } from '@material-ui/core';
import StarBorderIcon from '@material-ui/icons/StarBorder';

import greenStar from '../../assets/images/icons/green_star.png';
import goldStar from '../../assets/images/icons/gold_star.png';
import DropDownReview from '../common/DropDownReview';

const ReviewHeader = (props) => {
    return (
        <div className="reviews-comments-header fl-wrap">
            <h4>
                <Link to={`/profile/${props.review.user.slug}/home`}>
                    {props.review.user.first_name} {props.review.user.last_name} 
                    {/* {props.user.city && (<span> | {props.user.city}, {props.user.country}</span>)} */}
                </Link>    
                {props.review.user.rank && (
                    <Tooltip title={props.review.user.rank === 'gold' ? "Gold Star Member" : "Green Star Member"} placement="bottom">
                        <img 
                            src={props.review.user.rank === 'gold' ? goldStar : greenStar}
                        />
                    </Tooltip>
                )}
            </h4>
            <div className="review-score-user">
                <div className="listing-rating">
                    <Rating 
                        size="small" 
                        precision={0.5} 
                        value={parseFloat(props.review.rating)} 
                        readOnly
                        emptyIcon={
                            <StarBorderIcon fontSize="inherit" color="disabled" />
                        } 
                    />
                </div>
                <span className="review-score-user_item">{props.review.rating}</span>
                {props.isUser && (
                    <DropDownReview 
                        listing={props.review.listing}
                        review={props.review}
                    />
                )}
            </div>
            <div className="review-friends text-left">
                <Tooltip title="Followers" placement="bottom">	
                    <span>
                        <i className="fal fa-user-friends"></i>{props.review.user.total_followers}
                    </span>
                </Tooltip>
                <Tooltip title="Reviews" placement="bottom"> 
                    <span>
                        <i className="fal fa-star-half-alt"></i>{props.review.user.total_reviews}
                    </span>
                </Tooltip>
                <Tooltip title="Likes" placement="bottom">
                    <span>
                        <i className="fal fa-heart"></i>{props.review.user.total_like_votes}
                    </span>
                </Tooltip>
            </div>
        </div>
    );
};

export default ReviewHeader;